module.exports = __webpack_public_path__ + "static/media/ReactFirebase.dd717418.svg";